// @flow
import cities from './citys.json'

export async function fetchCities(): Promise<City[]> {
  return cities 
}